export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const SITE_TITLE_MAIN = "Jade Finance";
export const SITE_TITLE_BOAT = "Jade Boat Loans";
export const SITE_TITLE_CAR = "Jade Car Loans";
export const SITE_TITLE_CARAVAN = "Jade Caravan Finance";
export const SITE_TITLE_EQUIPMENT = "Jade Equipment Finance";
export const SITE_TITLE_TRUCK = "Jade Truck Loans";
export const SITE_TITLE_BIKE = "Jade Bike Loans";
export const SITE_TITLE_AGRI = "Jade Agri Finance";

// Scholarship Form
export const FORM_START_HEADING = "Scholarship Eligibility Form";
export const FORM_END_HEADING = "Scholarship Submission Received";
export const FORM_END_CONTENT =
	"Thanks for your application! Applications close 1 November, and we will announce the winner on 1 December. Best of luck!";

// Initialised Contact Form Types
export const CONTACT_GENERAL = "General Enquiry Form";
export const CONTACT_PARTNER = "Partner Enquiry Form";
export const CONTACT_SCHOLARSHIP = "Scholarship Eligibility Form";

// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Jade Finance": {
		themeColor: "#19cc76",
		hoverColor: "#16ac6b",
		themeHeaderTxt: "#142f48",
		bulletBG: "#bbf7d0",
	},
	"Jade Boat Loans": {
		themeColor: "#599bf8",
		hoverColor: "#457ac4",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DBEAFE",
	},
	"Jade Car Loans": {
		themeColor: "#da1710",
		hoverColor: "#c51a14",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFC9C9",
	},
	"Jade Caravan Finance": {
		themeColor: "#FF7901",
		hoverColor: "#e46701",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFD6A7",
	},
	"Jade Equipment Finance": {
		themeColor: "#069f2e",
		hoverColor: "#068026",
		themeHeaderTxt: "#142f48",
		bulletBG: "#D0FAE5",
	},
	"Jade Truck Loans": {
		themeColor: "#ffc913",
		hoverColor: "#e9b814",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FEF9C2",
	},
	"Jade Bike Loans": {
		themeColor: "#0e8fbe",
		hoverColor: "#0d7ea7",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DFF2FE",
	},
	"Yes Home Loans": {
		themeColor: "#FFAA22",
		hoverColor: "#F69D0E",
		themeHeaderTxt: "#142F48",
		bulletBG: "#FFDFB8",
	},
};

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};
